var base = require('settings/teams/team-members');

Vue.component('spark-team-members', {
    mixins: [base],

    data() {
        return {
            deleted_users: [],

            roles: [],
            userTypes: {
                'sales': 'Sales',
                'project-management' : 'Project Management',
                'sales and project-management' : 'Sales and Project Management'
            },

            updatingTeamMember  : null,
            deletingTeamMember  : null,
            activatingTeamMember: null,

            updateTeamMemberForm: $.extend(true, new SparkForm({
                role: '',
                color: '',
                user_type: '',
                ryvit_employee_id: '',
            }), Spark.forms.updateTeamMember),

            deleteTeamMemberForm: new SparkForm({}),
            ownerArray: [],
            systemAdminArray: [],
            adminArray: [],
            activeMemberArray: []
        }
    },

    created() {
        this.getRoles();
    },

    computed: {
        activeMembers() {
            let allActiveMembers = this.team.users.filter((m) => (m.pivot.active && m.is_registered));
            this.activeMemberArray = allActiveMembers;
            return allActiveMembers;
        },
        inactiveMembers() {
            return this.team.users.filter((m) => !m.pivot.active && m.is_registered);
        }
    },

    methods: {
        isAdminOrAbove(member) {
            const userTeam = _.findIndex(this.user.teams, {id: this.team.id});
            const userRole = this.user.teams[userTeam].pivot.role;
            // return (this.user.id === this.team.owner_id && this.user.id !== member.id) ||
            //        ((userRole === 'admin' || userRole === 'administrative') && this.user.id !== member.id && member.id !== this.team.owner_id);
            return (userRole === 'admin' || userRole === 'owner');
        },
        isNotOwner(member) {
            return (member.id !== this.team.owner_id);
        },

        approveTeamMemberActivation(member) {
            this.activatingTeamMember = member;

            $('#modal-activate-member').modal('show');
        },

        activateMember() {
            axios.put(route('api.deleted-users.update', {deleted_user: this.activatingTeamMember.id}))
                 .then((s) => {
                     Bus.$emit('updateTeam');

                     $('#modal-activate-member').modal('hide');
                 })
        },

        getRoles() {
            axios.get(`/settings/${Spark.teamsPrefix}/roles`)
                .then(response => {
                    this.roles = response.data.filter(item => item.value !== 'developer');
                });
        },

        editTeamMember(member) {
            this.updatingTeamMember = member;
            this.updateTeamMemberForm.role = member.pivot.role;
            this.updateTeamMemberForm.color = member.pivot.color ?? '#FFFFFF';
            this.updateTeamMemberForm.user_type = member.user_type;
            this.updateTeamMemberForm.ryvit_employee_id = member.ryvit_employee_id;

            $('#modal-update-team-member').modal('show');
        },

        isAdministrativeOrAbove(member) {
            const userTeam = _.findIndex(this.user.teams, {id: this.team.id});
            const userRole = this.user.teams[userTeam].pivot.role;
            return (this.user.id === this.team.owner_id && this.user.id !== member.id) ||
                ((userRole === 'administrative') && this.user.id !== member.id && member.id !== this.team.owner_id);
        },

        checkRole(role, id){
            axios.post(`/settings/teams/${this.team.id}/team-data`, {})
                .then((response) => {

            let allMembers = response.data.users;
            let owner = [];
            let systemAdmin = [];
            let admin = [];
            let user = null;
            response.data.users.forEach(item => {
                if(item.pivot.role == 'owner'){
                    owner.push(item);
                }else if(item.pivot.role == 'admin'){
                    systemAdmin.push(item);
                }else if(item.pivot.role == 'administrative'){
                    admin.push(item);
                }

                if(item.id == id){
                    user = item;
                }
            });
            response.data.user_invitation.forEach(invitationItem => {
                if (invitationItem.role == 'owner') {
                    owner.push(invitationItem);
                } else if (invitationItem.role == 'admin') {
                    systemAdmin.push(invitationItem);
                } else if (invitationItem.role == 'administrative') {
                    admin.push(invitationItem);
                }
            });
            if(this.roles.length > 0){
                if((owner.length > 0 && role == 'owner')){
                    let message = '';
                    let roleNumber = '';
                    if(role == 'owner'){
                        message = 'You can assign the Owner role only to 1 user. Assign another role to the current Owner and try again';
                    }
                    this.showErrorPopup(message);
                    this.updateTeamMemberForm.role = user.pivot.role;
                    return false;
                }
            }

            this.updateTeamMemberForm.role = role;
            });
        },

        showErrorPopup(message){
            Swal.fire({
                icon: 'error',
                text: message,
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Close'
            }).then((result) => {

            });
        },

        sendOwnerTeamInvite(member) {
            let self = this;
            axios.post(route('settings.owner.team.invite'), {id: member.id})
                .then((response) => {
                    self.getToast().fire({
                        type: response.data.status,
                        title: response.data.message
                    });
                })
                .catch((error) => {
                    self.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong!'
                    });
                });
        }
    }
});
